module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/051-cayman-islands-1c58614173a924345a7bf5abe379385b.svg";